<template>
    <v-container fluid class="b-container">
        <v-sheet class="pa-3">
            <v-tabs
                v-model="tab"
                color="secondary"
                :vertical="$vuetify.breakpoint.mdAndDown"
            >
                <v-tab
                    v-for="tab in tabs"
                    :key="tab.name['en']"
                    v-text="tab.name[lang]"
                    :to="tab.to"
                    class="
                        text-capitalize
                        d-flex
                        justify-start justify-md-center
                        px-3
                    "
                ></v-tab>
            </v-tabs>
        </v-sheet>

        <v-tabs-items v-model="tab" class="mt-3">
            <router-view></router-view>
        </v-tabs-items>
    </v-container>
</template>

<script>
import { mapState } from "vuex";
export default {
    name: "Redemptions",

    data() {
        return {
            tab: this.$route.path,
        };
    },

    computed: {
        lang() {
            return this.$route.params.lang;
        },
        ...mapState(["loading", "isSuperAdmin"]),

        tabs() {
            let tabs = 
             [
                {
                    name: {
                        el: "Αγαθά",
                        en: "Products",
                        it: "Prodotti",
                    },
                    to: `/${this.lang}/loyaltyPanel/redemptions/products`,
                },
                {
                    name: {
                        el: "Δωροεπιταγές",
                        en: "Vouchers",
                        it: "Buoni Regalo",
                    },
                    to: `/${this.lang}/loyaltyPanel/redemptions/vouchers`,
                },
               
            ];
            if(this.isSuperAdmin){
                tabs.push({
                    name: {
                        el: "Όλα",
                        en: "All",
                        it: "Tutti",
                    },
                    to: `/${this.lang}/loyaltyPanel/redemptions/all`,
                })
            }
            return tabs;
        },
    },

    watch: {
        $route: {
            immediate: true,
            handler(val) {
                if (val.path === `/${this.lang}/loyaltyPanel/redemptions`) {
                    this.$router.push(
                        `/${this.lang}/loyaltyPanel/redemptions/products?page=1`
                    );
                }
            },
        },
    },
};
</script>
